import { StringHelper } from "../Helpers/StringHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerHasValuePropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerHasValueProperties = {
    [name in keyof PropertyComparerHasValuePropertyValues]: Property<PropertyComparerHasValuePropertyValues[name]>
};

export interface IPropertyComparerHasValue extends IPropertyComparer, PropertyComparerHasValueProperties
{
}

export class PropertyComparerHasValue extends PropertyComparer<PropertyComparerHasValuePropertyValues> implements IPropertyComparerHasValue
{
    public static override classNamespace = NAMESPACE + "PropertyComparerHasValue";
    public static override className = "PropertyComparerHasValue";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return propertyValue !== undefined && propertyValue !== null && !StringHelper.isNullOrWhitespace(propertyValue.toString());
    }

    // #endregion
}

